var React = require("react");
var Radium = require("radium");

var style = {
	position: "absolute",
	width: "90%",
	height: "90%",
	margin: 1,
	pointerEvents: "none"
};

var pathStyle = {
	base: {
		stroke: "#3f61d4",
		strokeWidth: "13px",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeDasharray: "126.37, 126.37",
		strokeDashoffset: "127",
		transition: "stroke-dashoffset 0.1s ease-in-out 0s",
		fill: "none"
	},

	checked: {
		strokeDashoffset: "0"
	}
};

module.exports = Radium(
	React.createClass({

		propTypes: {
			checked: React.PropTypes.bool.isRequired
		},

		render: function() {
			var me = this, props = me.props;

			return (
				<svg viewBox="-8 -20 100 100" style={style} className={props.className}>
					<polyline
						style={[
							pathStyle.base,
							props.checked ? pathStyle.checked : undefined
						]}
						points="5 34.46 27.41 56.87 79.28 5"
						/>
				</svg>
			);
		}

	})
);


// WEBPACK FOOTER //
// ./src/components/Checkbox/Sign.jsx